/*
 * An AI Router is a `router` step whose route is chosen by a decision model (Jev) from
 * `options.decision` instead of by `options.routeSelectorCode`. This is the ONE test for it — the API
 * validator, the run engine, the step runner and the Pieve UI all import it, so "what is an AI Router"
 * cannot mean different things on either side of the API boundary.
 *
 * Presence alone decides it, not shape: a malformed `decision` is still an AI Router, and the validator
 * reports exactly what is wrong with it instead of silently treating the step as a code router.
 */
export const isPieveWorkflowDecisionRouter = (step) => {
  const type = String(step?.type || '')
    .trim()
    .toLowerCase();
  const decision = step?.options?.decision;

  return type === 'router' && decision !== undefined && decision !== null;
};
